import React from 'react';
import css from './index.css';
import {GitHub,LinkedIn,Instagram} from "@material-ui/icons";
import {useTranslation} from 'react-i18next';

export default function Footer() {

   const {t,i18n}=useTranslation();

  return (
    <footer>
    {t('footertext.label')} Aziz MobaraK<br/>
    <ul style={{ listStyle:"none" }}>
    <li style={{ float:"left" }}><GitHub/></li>
    <li style={{ float:"left" }} ><LinkedIn/></li>
    <li style={{ float:"left" }}><Instagram/></li>
    </ul>
    </footer>
  );
}
